import Api from '@/api/api'

export default {
    getReports() {
        return Api.get(`/api/reportmaster/GetAllReportsForAdmin`)
    },
    getInitialData() {
        return Api.get(`/api/InitialData/GetSuperAdminInitialData`);
    },
    addReport(data) {
        return Api.post(`/api/reportmaster/AddReportMaster`, data);
    },
    updateReport(editId, data) {
        return Api.put(`/api/reportmaster/UpdateReportMaster?reportId=${editId}`, data);
    },
}